
import axiosInstance from '../../../../config/axiosInstance';
import { EmailingValidation } from "../../views/EmailNotification/Validation/EmailingValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  
  event.preventDefault();
  const formErrors = EmailingValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      
      const token = localStorage.getItem('token');
      if (!token || token=="null") {
          redirectCallback();
          return; // Return early to prevent further execution
      }
      
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
     
      const response = await axiosInstance.post(`/Setup/UpdateNotification`, formData);
     
      console.log('Form submitted and data posted:');      
      //setData(responseData);   
    redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };